/**
 * PdfPreviewInlineDialog - Modal de pré-visualização de PDF (cotação/pedido) via iframe
 * (extraído de Compras.jsx). Mantém o comportamento original (token na query).
 */
import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from '../ui/dialog';
import { Button } from '../ui/button';
import { FileText, X, Download } from 'lucide-react';

const PdfPreviewInlineDialog = ({ preview, onClose, onDownload }) => {
  return (
    <Dialog open={!!preview} onOpenChange={() => onClose()}>
      <DialogContent className="max-w-5xl h-[90vh] flex flex-col">
        <DialogHeader className="flex-shrink-0">
          <DialogTitle className="flex items-center justify-between">
            <span className="flex items-center gap-2">
              <FileText className="w-5 h-5" />
              Pré-visualização: {preview?.type === 'cotacao' ? 'Cotação' : 'Pedido'} {preview?.numero}
            </span>
            <Button
              variant="ghost"
              size="sm"
              onClick={() => onClose()}
            >
              <X className="w-4 h-4" />
            </Button>
          </DialogTitle>
        </DialogHeader>

        <div className="flex-1 min-h-0 bg-gray-100 rounded-lg overflow-hidden">
          {preview && (
            <iframe
              src={`/api/${preview.type === 'cotacao' ? 'cotacoes' : 'pedidos-compra'}/${preview.id}/pdf/preview?token=${localStorage.getItem('nautilus_token')}`}
              className="w-full h-full border-0"
              title={`Preview ${preview.type} ${preview.numero}`}
            />
          )}
        </div>

        <DialogFooter className="flex-shrink-0 mt-4">
          <Button variant="outline" onClick={() => onClose()}>
            Fechar
          </Button>
          <Button onClick={() => preview && onDownload(preview)}>
            <Download className="w-4 h-4 mr-1" />
            Baixar PDF
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default PdfPreviewInlineDialog;
